import type { ReactElement } from 'react';

interface StatCardProps {
  label: string;
  value: string | number;
  sub?: string;
  color?: string;
}

export default function StatCard({
  label,
  value,
  sub,
  color = 'text-theme-text',
}: StatCardProps): ReactElement {
  return (
    <div className="bg-theme-surface rounded-lg p-4">
      <div className="text-theme-text-secondary text-sm">{label}</div>
      <div className={`text-2xl font-bold ${color}`}>{value}</div>
      {sub && <div className="text-theme-text-tertiary text-xs">{sub}</div>}
    </div>
  );
}
